<template>
  <div class="container">
    <card
      v-for="item in Object.keys(results)"
      :key="item"
      :title="`${item} (${(data[item] && data[item].length) || 0} results)`"
    >
      <Table
        :items="data[item] || []"
        :columns="(results[item] && results[item].columns) || []"
        :links="results[item] && results[item].links"
        :filterProp="results[item] && results[item].filterProp"
      />
    </card>
  </div>
</template>

<script>
import Card from "@/components/Card";
import Table from "@/components/Table";
import { generationSessionType, isZipGenerationSession } from "@/utils/generationSessions";

export default {
  data() {
    return {
      results: {
        users: {
          columns: [
            { label: "Name", prop: "name" },
            { label: "Email", prop: "email" },
          ],
          links: [
            {
              label: "View user",
              to: (item) => `/customers/user/${item.email}`,
            },
          ],
          filterProp: "email",
        },
        teams: {
          columns: [
            { label: "Name", prop: "name" },
            { label: "Slug", prop: "slug" },
          ],
          links: [
            { label: "View team", to: (item) => `/customers/team/${item.id}` },
          ],
          filterProp: "name",
        },
        projects: {
          columns: [
            { label: "Name", prop: "name" },
            { label: "Slug", prop: "slug" },
          ],
          links: [
            {
              label: "View project",
              to: (item) => `/customers/project/${item.id}`,
            },
          ],
          filterProp: "name",
        },
        playgrounds: {
          columns: [
            { label: "ID", prop: "id" },
            { label: "Name", prop: "name" },
            { label: "Type", formatter: generationSessionType },
          ],
          links: [
            {
              label: "View playground",
              to: (item) => `/customers/playground/${item.id}`,
              visible: (item) => !isZipGenerationSession(item),
            },
            {
              label: "Open ZIP",
              href: (item) => item.target_url,
              visible: (item) => isZipGenerationSession(item) && Boolean(item.target_url),
            },
          ],
          filterProp: "name",
        },
      },
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  components: {
    Card,
    Table,
  },
};
</script>

<style scoped>
.container > * + * {
  margin-top: 10px;
}
</style>
